import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import MainLayoutWrapper from '../components/MainLayoutWrapper';
import Login from '../pages/Auth/Login/Login';
import ChangePassword from '../pages/Auth/Login/ChangePassword';
import ResetPassword from '../pages/Auth/Login/ResetPassword';
import FirstTimeResetPassword from '../pages/Auth/Login/FirstTimeResetPassword';
import ForgotPasswordSent from '../pages/Auth/Login/ForgotPasswordSent';
import RequireNoAuth from '../routes/component/RequireNoAuth';
import RequireJWT from '../routes/component/RequireJWT';
import RequireAuth from '../routes/component/RequireAuth';
import NotFound from '../routes/component/NotFound';

const Groups = React.lazy(() => import('../pages/BusinessEntity/Groups/group'));
const Company = React.lazy(() => import('../pages/BusinessEntity/Company/company'));
const TradingPartners = React.lazy(() => import('../pages/MasterData/TradingPartners/tradingpartners'));
const Users = React.lazy(() => import('../pages/Administration/Users/User'));
const Templates = React.lazy(() => import('../pages/Templates/Templates/templates'));
const AccountReceivable = React.lazy(() => import('../pages/DocumentUpload/DocumentUpload/AccountReceivable/AccountReceivable'));
const AccountPayable = React.lazy(() => import('../pages/DocumentUpload/DocumentUpload/AccountPayable/AccountPayable'));
const Upload = React.lazy(() => import('../pages/DocumentUpload/DocumentUpload/AccountReceivable/Upload'));
const UploadPayable = React.lazy(() => import('../pages/DocumentUpload/DocumentUpload/AccountPayable/UploadPayable'));
const Dashboard = React.lazy(() => import('../pages/Dashboard/Dashboard'));
const Profile = React.lazy(() => import('../pages/Settings/Profile'));
const CompanyProfile = React.lazy(() => import('../pages/Settings/CompanyProfile'));
const Contact = React.lazy(() => import('../pages/Contact/Contact'));
const DocumentSummaryReport = React.lazy(() => import('../pages/Reports/DocumentSummary/DocumentSummaryReport'));
const TotalTaxAmountReport = React.lazy(() => import('../pages/Reports/TotalTaxAmount/TotalTaxAmountReport'));

const withRoles = (element, allowedRoles = ['System Admin', 'Company Admin']) => (
    <RequireAuth allowedRoles={allowedRoles}>{element}</RequireAuth>
);

export default function RouterApp({ isDarkMode, toggleTheme }) {
    return (
        <BrowserRouter basename=''>
            <Routes>
                <Route path="/" element={<RequireNoAuth><Navigate to="/login"/></RequireNoAuth>} />

                <Route path='/login' >
                    <Route index element={<RequireNoAuth><Login /></RequireNoAuth>} />
                </Route>

                <Route path='/changepassword' >
                    <Route index element={<RequireNoAuth><ChangePassword /></RequireNoAuth>} />
                </Route>

                <Route path='/resetpassword' >
                    <Route index element={<RequireNoAuth><ResetPassword /></RequireNoAuth>} />
                </Route>

                <Route path='/forgot-password' >
                    <Route index element={<RequireNoAuth><ResetPassword /></RequireNoAuth>} />
                </Route>

                <Route path='/forgot-password-sent' >
                    <Route index element={<RequireNoAuth><ForgotPasswordSent /></RequireNoAuth>} />
                </Route>

                <Route path='/reset-password' >
                    <Route index element={<RequireNoAuth><ChangePassword /></RequireNoAuth>} />
                </Route>

                <Route path='/firsttimeresetpassword/:tokenId?' >
                    <Route index element={<RequireNoAuth><FirstTimeResetPassword /></RequireNoAuth>} />
                </Route>

                <Route element={<RequireJWT><MainLayoutWrapper isDarkMode={isDarkMode} toggleTheme={toggleTheme} /></RequireJWT>}>
                    <Route path="dashboard" element={withRoles(<Dashboard />)} />
                    <Route path="profile" element={withRoles(<Profile />)} />
                    <Route path="company-profile" element={withRoles(<CompanyProfile />)} />
                    <Route path="contact" element={withRoles(<Contact />)} />
                    <Route path="businessentity/Groups" element={withRoles(<Groups />)} />
                    <Route path="businessentity/Company" element={withRoles(<Company />)} />
                    <Route path="masterdata/TradingPartners" element={withRoles(<TradingPartners />)} />
                    <Route path="administration/Users" element={withRoles(<Users />)} />
                    <Route path="templates/Templates" element={withRoles(<Templates />, ['System Admin'])} />
                    <Route path="documentupload">
                        <Route path="AccountReceivable" element={withRoles(<AccountReceivable />)} />
                        <Route path="AccountPayable" element={withRoles(<AccountPayable />)} />
                    </Route>
                    <Route path="documentupload/AccountReceivable">
                        <Route path="Upload" element={<Upload />} />
                    </Route>
                    <Route path="documentupload/AccountPayable">
                        <Route path="UploadPayable" element={<UploadPayable />} />
                    </Route>
                    <Route path="reports/DocumentSummaryReport" element={<DocumentSummaryReport />} />
                    <Route path="reports/TotalTaxAmountReport" element={<TotalTaxAmountReport />} />
                </Route>

                <Route path="*" element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    );
}
